import React, { useState, useEffect } from 'react';
import axios from 'axios';

const SchoolInput = (props) => {
    const [schools, setSchools] = useState([]);
    const [faculties, setFaculties] = useState([]);
    const [defaultFaculty, setDefaultFaculty] = useState(props.defaultFaculty);
    const [showSchool, setShowSchool] = useState(props.defaultFaculty == "Other" ? false : true);
    useEffect(() => {              
        props.schools.forEach(r => {
            if (r.schoolText == props.defaultSchool) {
                setDefaultFaculty(r.facultyText)              
                setSchools(props.schools.filter(item => item.facultyText == r.facultyText));
            }
        });
        var uniquefaculties = new Set(props.schools.map(item => item.facultyText));
        setFaculties([...uniquefaculties]); // convert Set to Array    
    }, [props.defaultSchool]);
    const prepareFaculties = (f, i) => {
        return <option key={i} value={f}>{f}</option>;
    }
   
    const handleChange = (e) => {
        setDefaultFaculty(e.target.value);
        props.handleFacultyChange(e.target.value);
        setSchools(props.schools.filter(item => item.facultyText == e.target.value));
        //reset school
        props.handleSchoolChange("");
        // console.log(responseData.filter(item => item.facultyText == e.target.value));
        if (e.target.value == "Other") {
            setShowSchool(false);
        } else {
            setShowSchool(true);
        }
   
    }
    const prepareSchools = (s, i) => {
        return <option key={s.schoolID} value={s.schoolText} > { s.schoolText }</ option>;
        }
        return (
            <div className="row">
                <div className="rowItem">
                    <select value={props.defaultFaculty} onChange = { handleChange } >
                <option value="" disabled>Choose Faculty</option>
                        {faculties.length > 0 ? faculties.map((f, i) => prepareFaculties(f, i)) : <option />}
                        <option value="Other">Other</option>
                </select>
                </div>
                {showSchool ? <div className="rowItem">
                    <select value={props.defaultSchool} onChange={(e) => props.handleSchoolChange(e.target.value)} >
                        <option value="" disabled >Choose School</option>
                        {schools.length > 0 ? schools.map((s, i) => prepareSchools(s, i)) : <option />}
                    </select>
                </div> : <div className="rowItem">
                        <label htmlFor="unit">Which unit are you from?</label> <input type="text" name="unit" value={props.defaultSchool} onChange={(e) => props.handleSchoolChange(e.target.value)} autoFocus /></div>}
              
        </div>
    )
}
export default SchoolInput;